import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const MY_LIBRARY_STAFF = gql`
  query MyLibraryStaff {
    library {
      id
      name
      libraryNumber
      staff {
        id
        role
        isServiceable
        createdAt
        user {
          id
          firstName
          lastName
          email
          contactNo
          userNumber
          isActive
        }
      }
    }
  }
`;
